// extracted by mini-css-extract-plugin
export default {"gridTemplate":"GridLayout_gridTemplate__9KL-7"};